'use client';

import { useEffect, useState } from 'react';

import { Alignable, Tab, TabList, Tabs as TabsTrilogy } from '@bytel/trilogy-react';

export type TabItem = { name: string; label: string };

type TabsProps = {
    items: TabItem[];
    onClick?: (activeTab: TabItem) => void;
    activeTab?: TabItem;
};

export function Tabs({ items = [], onClick, activeTab }: Readonly<TabsProps>) {
    const [currentTab, setCurrentTab] = useState<TabItem | undefined>(activeTab ?? items[0]);

    const onTabChange = (activeTab: TabItem) => {
        setCurrentTab(activeTab);
        onClick?.(activeTab);
    };

    useEffect(() => {
        setCurrentTab(activeTab ?? items[0]);
    }, [activeTab]);

    return (
        <TabsTrilogy small>
            <TabList align={Alignable.ALIGNED_CENTER}>
                {items.map((item) => (
                    <Tab
                        key={item.name}
                        label={item.label}
                        active={item.name === currentTab?.name}
                        onClick={() => onTabChange(item)}
                    />
                ))}
            </TabList>
        </TabsTrilogy>
    );
}
